import * as React from "react";
import moment from "moment/moment";
import { BaseUnit, SharedTooltipContext } from "@progress/kendo-react-charts";
import { StandardTimeSeriesTooltipContent } from "@iliotech/widgets";
import { TimeSeriesStackedChart } from "@iliotech/widgets";
import { TimeSeriesChartItem } from "@iliotech/widgets";

interface IProps {
  timeSeriesData: TimeSeriesChartItem[];
  currencyFormatter?: (v?: number) => string;
  daysRange?: number;
  height?: number;
  width?: number;
}

export const BreakDownChart = ({
  timeSeriesData,
  currencyFormatter,
  daysRange,
  height,
  width,
}: IProps) => {
  const baseUnit: BaseUnit = (daysRange || 0) < 31 ? "days" : "months";
  const [monthly, setMonthly] = React.useState(false);
  const minValue = timeSeriesData
    .map((a) => a.entries)
    .flat()
    .map((a) => a.value)
    .reduce((a, b) => Math.min(a, b), 0);

  const categoryAxisFormatter = (e?: string, ev?: any) => {
    if (!e) return "";
    if (ev?.format?.skeleton === "yyMMM") {
      setMonthly(true);
      return moment(e).format("MMM' YY");
    }
    setMonthly(false);
    if (baseUnit === "days") {
      return moment(e).format("DD MMM' YY");
    }
    return moment(e).format("MMM' YY");
  };

  const tooltipFormatter = (e?: string) => {
    if (monthly) {
      return moment(e).format("MMM' YY");
    }
    if (baseUnit === "days") {
      return moment(e).format("DD MMM' YY");
    }
    return moment(e).format("MMM' YY");
  };

  const OverriddenTooltip = (
    info: SharedTooltipContext,
    valueFormatter?: (v?: number) => string,
    categoryFormatter?: (v?: string) => string,
    settings?: any
  ) => {
    return (
      <StandardTimeSeriesTooltipContent
        info={info}
        valueFormatter={valueFormatter}
        categoryFormatter={tooltipFormatter}
        settings={settings}
      />
    );
  };

  const aggregateFunction = (
    values: any,
    series: any,
    dataItems: any,
    category: any
  ) => {
    const lastDate = dataItems.sort((a: any, b: any) =>
      moment(a.date).diff(moment(b.date))
    )[0]?.date;
    const lastDateItems = dataItems.filter((a: any) =>
      moment(a.date).isSame(lastDate, "day")
    );
    return lastDateItems?.reduce((a: any, b: any) => a + b.value, 0);
  };

  return (
    <TimeSeriesStackedChart
      height={height}
      width={width}
      aggregate={aggregateFunction}
      items={timeSeriesData}
      categoryAxisFormatter={categoryAxisFormatter}
      valueAxisFormatter={currencyFormatter}
      axisCrossingValue={minValue}
      baseUnit={baseUnit}
      baseUnitStep={undefined}
      sharedTooltipRender={OverriddenTooltip}
    />
  );
};

export default BreakDownChart;
